import { FormattedMessage } from "react-intl";
import { Button, ChevronIcon, Flex, Text } from "@paguelofacil/pf-components";

import { language, languageDefault } from "../../services/utils/Language";

export const InformationHowPay = ({ setShowInfoAboutPaymentCrypto }) => {
    return (
        <Flex direction="column" align="flex-start" gap="0.5rem">
            <Button
                size="xs"
                variant="transparent"
                leftIcon={<ChevronIcon direction="left" size="18" />}
                handleClick={setShowInfoAboutPaymentCrypto}
                widthAuto
                style={{ padding: "0", marginBottom: "1rem" }}
            >
                <Text variant="body6" weight="regular">
                    <FormattedMessage
                        id={language.steps_to_pay_with_crypto}
                        defaultMessage={languageDefault.steps_to_pay_with_crypto}
                    />
                </Text>
            </Button>
            <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                <li>
                    <Text variant="body6" weight="regular">
                        <FormattedMessage id={language.select_crypto} defaultMessage={languageDefault.select_crypto} />
                    </Text>
                </li>
                <li>
                    <Text variant="body6" weight="regular">
                        <FormattedMessage
                            id={language.scan_qr_crypto_address}
                            defaultMessage={languageDefault.scan_qr_crypto_address}
                        />
                    </Text>
                </li>
                <li>
                    <Text variant="body6" weight="regular">
                        <FormattedMessage
                            id={language.make_payment_crypto}
                            defaultMessage={languageDefault.make_payment_crypto}
                        />
                    </Text>
                </li>
            </ul>
            <Text variant="body6" weight="regular" style={{ marginLeft: "1rem" }}>
                <FormattedMessage id={language.ready} defaultMessage={languageDefault.ready} />
            </Text>
        </Flex>
    );
};
